import { authHeaders } from '@/utils/authToken';
import type { Opportunity, OpportunityApplication } from '@/types';

export const opportunityService = {
  async list(filters?: {
    vehicle_category?: string;
    zone_name?: string;
    priority?: string;
    page?: number;
    limit?: number;
  }): Promise<{ data: Opportunity[]; total: number }> {
    const params = new URLSearchParams();
    if (filters?.vehicle_category) params.set('vehicle_category', filters.vehicle_category);
    if (filters?.zone_name) params.set('zone_name', filters.zone_name);
    if (filters?.priority) params.set('priority', filters.priority);
    if (filters?.page) params.set('page', String(filters.page));
    if (filters?.limit) params.set('limit', String(filters.limit));

    const res = await fetch(`/api/opportunities?${params}`, { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return { data: json.data, total: json.total };
  },

  async apply(opportunityId: string, data: { vehicle_id?: string; notes?: string }): Promise<OpportunityApplication> {
    const res = await fetch(`/api/opportunities/${opportunityId}/apply`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(data),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async myApplications(): Promise<OpportunityApplication[]> {
    const res = await fetch('/api/applications', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
